import { Input } from "@nova/ds-component-input"
import React, { ComponentProps, forwardRef, useState } from "react"
import * as Icons from "@nova/component-icons"

export const PasswordInput = forwardRef<
    HTMLInputElement,
    Omit<ComponentProps<typeof Input>, "type" | "rightItem">
>((props, ref) => {
    const [isHidden, setIsHidden] = useState(true)
    return (
        <Input
            {...props}
            ref={ref}
            type={isHidden ? "password" : "text"}
            rightItem={
                <Icons.Icon
                    Icon={isHidden ? Icons.VisibilityEye : Icons.VisibilityEyeOff}
                    onClick={() => setIsHidden((prev) => !prev)}
                    className="cursor-pointer text-gray-300 hover:text-gray-100 transition-colors"
                />
            }
        />
    )
})
